module.exports = {
    Website: require('./WebsiteRequest'),
    Account: require('./AccountRequest'),
    Insights: require('./InsightsRequest'),
    Event: require('./EventRequest'),
    Ems: require('./EmsRequest'),
    Content: require('./ContentRequest'),
    Blog: require('./BlogRequest'),
    Shop: require('./ShopRequest'),
    Helpdesk: require('./HelpdeskRequest'),
    Godaddy: require('./GodaddyRequest'),
    Core: require('./CoreRequest'),
    Yfp: require('./YfpRequest'),
    Contacts: require('./ContactRequest'),
    Tracker: require('./TrackerRequest'),
    Stats: require('./StatsRequest'),
    Webinar: require('./WebinarRequest'),
    Newsletter: require('./NewsletterRequest'),
    Notification: require('./NotificationRequest'),
    Course: require('./CourseRequest'),
    Promo: require('./PromoRequest'),
    Sendible: require('./SendibleRequest')
}